var _style, _circle, _circle2, _circle3, _circle4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStressElevated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EEA508;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100.57,
    cy: 100,
    r: 90.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100.41,
    cy: 100.97,
    r: 79.52
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 63.39,
    cy: 77.46,
    r: 11.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 137.43,
    cy: 77.79,
    r: 11.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.49,128.42l68.97-0.15c0,0,6.41-0.2,6.55,5.55c0.1,1.32-0.11,5.37-6.07,5.81c-8.02,0.08-69.6,0.04-69.6,0.04 s-5.69,0.81-6.29-5.17C61.23,134.36,61.11,128.46,67.49,128.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressElevated);
export default __webpack_public_path__ + "static/media/StressElevated.a99a4b24c83a638a2627538344fda142.svg";
export { ForwardRef as ReactComponent };